import { render, staticRenderFns } from "./comp_Footer-Top.vue?vue&type=template&id=5fb25472&scoped=true"
import script from "./comp_Footer-Top.vue?vue&type=script&lang=js"
export * from "./comp_Footer-Top.vue?vue&type=script&lang=js"
import style0 from "./comp_Footer-Top.vue?vue&type=style&index=0&id=5fb25472&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb25472",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
